import heic2any from 'heic2any';
import { heicTo } from 'heic-to';

const JPEG_QUALITY = 0.9;

/**
 * Если файл HEIC/HEIF — конвертирует в JPEG и возвращает новый File.
 * Иначе возвращает файл без изменений.
 * Порядок попыток: heic-to → heic2any → Canvas
 */
async function convertViaCanvas(file) {
	const bitmap = await createImageBitmap(file);
	const canvas = document.createElement('canvas');
	canvas.width = bitmap.width;
	canvas.height = bitmap.height;
	const ctx = canvas.getContext('2d');
	ctx.drawImage(bitmap, 0, 0);
	bitmap.close();
	return new Promise((resolve, reject) => {
		canvas.toBlob((blob) => {
			if (!blob) {
				reject(new Error('heic_conversion_failed'));
				return;
			}
			const newName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
			resolve(new File([blob], newName, { type: 'image/jpeg' }));
		}, 'image/jpeg', JPEG_QUALITY);
	});
}

export async function convertHeicIfNeeded(file) {
	const ext = file.name.split('.').pop().toLowerCase();
	const isHeic = ext === 'heic' || ext === 'heif' || file.type === 'image/heic' || file.type === 'image/heif';

	if (!isHeic) return file;

	const newName = file.name.replace(/\.(heic|heif)$/i, '.jpg');

	// Попытка 1: heic-to (поддерживает iOS 18 HEVC)
	try {
		const blob = await heicTo({ blob: file, type: 'image/jpeg', quality: JPEG_QUALITY });
		return new File([blob], newName, { type: 'image/jpeg' });
	} catch (heicToError) {
		console.warn('[heicConverter] heic-to failed, trying heic2any:', heicToError?.message || heicToError);
	}

	// Попытка 2: heic2any
	try {
		const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: JPEG_QUALITY });
		const resultBlob = Array.isArray(blob) ? blob[0] : blob;
		return new File([resultBlob], newName, { type: 'image/jpeg' });
	} catch (heic2anyError) {
		console.warn('[heicConverter] heic2any failed, trying Canvas:', heic2anyError?.message || heic2anyError);
	}

	// Попытка 3: Canvas
	try {
		return await convertViaCanvas(file);
	} catch (canvasError) {
		console.error('[heicConverter] All conversion methods failed:', canvasError);
		throw new Error('heic_conversion_failed');
	}
}
